import React from "react";
import { Box, Flex, SimpleGrid } from "@chakra-ui/react";

import useSelectedParticipant from "context/session/VideoProvider/useSelectedParticipant";
import { useParticipants, useVideoContext } from "hooks/session";
import Participant from "./Participant";

const getColNums = (n: number) => {
  const squareRoot = Math.sqrt(n);
  return [Math.floor(squareRoot), Math.ceil(squareRoot)];
};

interface Props {
  gameStarted: boolean;
}

const ParticipantList: React.FC<Props> = ({ gameStarted }: Props ) => {
  const { room } = useVideoContext();
  const participants = useParticipants();
  const [
    selectedParticipant,
    setSelectedParticipant
  ] = useSelectedParticipant();

  return (
    <Box w="100%" h="100%">
      {selectedParticipant && selectedParticipant !== room?.localParticipant ? (
        <Participant
          key={selectedParticipant.sid}
          participant={selectedParticipant}
          enableScreenShare
          onClick={() =>  {setSelectedParticipant(selectedParticipant);}}
        />
      ) : participants.length > 0 ? (
        <SimpleGrid
          gap={3}
          columns={getColNums(participants.length)}
          w="100%"
          h="100%"
        >
          {participants.map(participant => (
            <Participant
              key={participant.sid}
              participant={participant}
              enableScreenShare
              onClick={() => setSelectedParticipant(participant)}
            />
          ))}
        </SimpleGrid>
      ) : (
        <Flex
          bgColor="blue.900"
          borderRadius="10px"
          justifyContent="center"
          alignItems="center"
          h="100%"
          w="100%"
        >
          Waiting for Client
        </Flex>
      )}
    </Box>
  );
};

export default ParticipantList;
